import { EventRepository } from '~repositories/EventRepository';
import { events, serviceQueries, query } from '@estee/elc-service-bus';
import { Event } from '~entities/Event';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { PRODUCT_CLICKED } from '../../constants/UseCasesConstants';
import { root } from '@estee/elc-universal-utils';
import { mapProductSkusById } from '../../utils/dataAggregator';
import { ISkuData } from './ProductNotifyMeTriggeredUseCase';

export interface IProductClickedPayload {
    [key: string]: string | string[] | number[];
}

export class ProductClickedUseCase {
    private eventRepository: EventRepository;
    private skuId: string;
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    private product: any;
    private positionIndex: number;

    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    constructor(skudId: string, pageType: string = '', positionIndex: number, product?: any) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.skuId = skudId;
        this.positionIndex = positionIndex;
        this.product = product;
    }

    public execute = async () => {
        let productInfo = this.product;
        if (!productInfo) {
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            const data = <any>await query(serviceQueries.GET_PRODUCT_DATA, {
                filterBy: { skus: { skuIds: [this.skuId] } }
            });
            const skuIdMap: ISkuData = data.reduce(mapProductSkusById, {});
            productInfo = skuIdMap[this.skuId];
        }

        // TODO: figure out a way to get productInfo from DataAggregator
        const productClickedPayload: IProductClickedPayload = {
            event_name: PRODUCT_CLICKED,
            event_category: 'ecommerce',
            event_action: 'product click',
            enh_action: PRODUCT_CLICKED,
            event_noninteraction: 'FALSE',
            event_label: `${productInfo.displayName} - PROD${productInfo.productId}`,
            product_position: [this.positionIndex],
            product_list: [root.location.pathname],
            product_id: [`PROD${productInfo.productId.toString()}`],
            product_name: [`${productInfo.displayName}`]
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.PRODUCT_CLICKED,
            type: 'link',
            payload: productClickedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
